import React, { Component } from 'react'
import { Route, withRouter, Redirect } from 'react-router-dom'
import UploadScreen from '../Components/BackgroundReplacement/UploadScreen'
import ClipprNav from '../Components/Common/ClipprNav'
import HotspotEdit from '../Components/HotspotEdit/HotspotEdit'
import Home from '../Components/SpyneHome/Home'
import View360 from '../Components/View360/View360'
import EditorsTrackerForm from '../Components/EditorsTrackerForm/EditorsTrackerForm'
import AddEditingProject from '../Components/EditorsTrackerForm/AddEditingProject'
import LandingPage from '../Components/SpyneHome/LandingPage'
import HomeBeta from '../Components/SpyneHome/HomeBeta'

class Routes extends Component {
    constructor(props){
        super(props)
        this.state={
            url : '',
            iSHotSpot : false,
            oldPath: '',
            homeUrl:''
        }
    }
    
    cookie = key=>((new RegExp((key || '=')+'=(.*?); ','gm')).exec(document.cookie+'; ') ||['',null])[1]

    componentDidMount = () => {
        this.setPathAndLoad();
    }

    componentDidUpdate = ()=>{
        this.setPathAndLoad();
        
        
    }


    setPathAndLoad = ()=>{
        try {
            let url = window.location.pathname

            if(url.includes('//')){
                url = url.replaceAll('//','/');
                const {protocol, host, search} = window.location;
                const newURL = `${protocol}//${host}${url}${search}`
                window.location.replace(newURL)
                return;
            }

            if(this.state.oldPath===url) return;


            if(url && url==='/'){
                sessionStorage.clear();
            }

            let urlContainsHotSpot = false;
            if(url && (url.match(/hotspot/gmi) || url.match(/admin/gmi))){
                urlContainsHotSpot = true;
            }
            let urlArr = url.split('/')
            if(urlArr.length === 4){
                this.setState({
                    ...this.state,
                    url: urlArr[2],
                    iSHotSpot: urlContainsHotSpot,
                    oldPath: url
                })
            }else{
                this.setState({
                    ...this.state,
                    url: urlArr[3],
                    iSHotSpot: urlContainsHotSpot,
                    oldPath: url,
                    homeUrl: urlArr[2]
                }) 
            }
        } catch (error) {
            //console.log(error)
        }
    } 

    

    render() {
        return (
            <>
                {
                    !this.state.iSHotSpot ? (
                        <div>
                            {<ClipprNav />}
                            <Route path={`/category/${this.state.url}/try`} exact component={UploadScreen}/>
                            <Route path={`/category/fabric/${this.state.url}/try`} exact component={UploadScreen}/>
                            <Route path={`/category/fabric`} exact component={UploadScreen}/>
                            <Route path={`/category/home-furnishing/${this.state.url}/try`} exact component={UploadScreen}/>
                            <Route path={`/category/home-furnishing`} exact component={UploadScreen}/>
                            <Route path="/" exact component={Home}/>
                            <Route path="/category/beta" exact component={HomeBeta}/>
                            {/* <Route path={`/category/${this.state.homeUrl}`} exact component={LandingPage}/> */}
                        </div>
                    ) : 
                    (
                        <div>
                            <Route path="/category/hotspot-edit" exact component={HotspotEdit}/>
                            <Route path="/category/hotspot-view" exact component={View360}/>
                            
                            <Route path="/admin/editors-tracker-form" exact component={EditorsTrackerForm}/>
                            <Route path="/admin/add-editing-project" exact component={AddEditingProject}/>
                        </div>
                    )
                }
            </>
        )
    }
}

export default withRouter(Routes)
